<template>
    <zen-one
        :showuserinfo="false"
        title="Cukai Tanah:: Pengecualian"
        :crumbs="crumbs"
    >
        <z-page
            :title="`Senarai Pengecualian (${total})`"
            :append-button="true"
        >
            <w-flex column :gap="3">
                <!-- <w-form> -->
                <w-form @submit.prevent="filter">
                    <w-flex column :gap="3">
                        <w-flex :columns="{ xs: 1 }" :gap="3">
                            <w-input v-model="searchParams.no_hm"
                                >No. HM</w-input
                            >
                            <w-input v-model="searchParams.no_mknk"
                                >No. MKNK</w-input
                            >
                            <w-input v-model="searchParams.pemilik"
                                >Nama Pemilik</w-input
                            >
                            <w-input v-model="searchParams.no_akaun"
                                >No. Akaun</w-input
                            >
                            <w-select
                            :items="districts"
                            label="Daerah"
                            v-model="searchParams.daerah"
                            :disabled="this.id_daerah >1"
                            style="color:blue;"
                        ></w-select>
                        </w-flex>


                    </w-flex>
                    <br>
                    <div class="mt2 text-right">
                             <w-button
                             bg-color="success"
                             class="ml1"
                             :loading="loading" @click="printExcel()">
                             <w-icon v-on="on" class=" mr2 "> fal fa-print</w-icon>
                                 &nbsp;Cetak&nbsp;
                             </w-button>

                             <w-button
                             bg-color="primary"
                             class="ml1 "
                             :loading="loading"
                             type="submit"
                             >
                                 <w-icon>fal fa-search</w-icon>&nbsp;Cari
                             </w-button>
                    </div>
                </w-form>
                <w-flex class="justify-end">
                    <inertia-link
                        :href="$route('cukai-tanah.daftarPengecualian')"
                    >
                        <w-button class="align-self-end">
                            Tambah Pengecualian&nbsp;
                            <w-icon v-on="on"> fal fa-plus </w-icon>
                        </w-button>
                    </inertia-link>
                </w-flex>
                <Table
                    :headers="pengecualian.headers"
                    :items="loading ? [] : pengecualian.items"
                    :loading="loading"
                >
                    <template #item-cell.id="{ item, label, header, index }">
                        {{
                            (pagination.currentPage - 1) * pagination.perPage +
                            index
                        }}
                    </template>

                    <template
                        #item-cell.tarikh_mula="{ item, label, header, index }"
                    >
                    <div v-if="item.tarikh_mula!=null">
                        {{ moment(item.tarikh_mula).format("DD-MM-YYYY") }}
                    </div>
                    <div v-else>
                        Tiada Tarikh Mula
                    </div>
                    </template>


                    <template
                        #item-cell.action="{ item, label, header, index }"
                    >
                        <inertia-link
                            :href="$route('cukai-tanah.kemaskiniPengecualian')"
                            :data="{ no_hm: item.no_hm }"
                        >
                            <w-tooltip top>
                                <template #activator="{ on }">
                                    <w-icon v-on="on"> fal fa-file </w-icon>
                                </template>
                                Papar
                            </w-tooltip>
                        </inertia-link>
                    </template>
                </Table>
                <TablePagination
                    :lastPage="getLastPage"
                    :currentPage="pagination.currentPage"
                    :perPage="pagination.perPage"
                    @onClick="onPaginationChange($event)"
                />
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import moment from "moment";
import ZResource from "@/Modules/z-resource";
import Table from "../Component/Table";
import TablePagination from "../Component/TablePagination";

export default {
    extends: ZResource,
    components: { Table, TablePagination },
    data() {
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                {
                    label: "Pengecualian",
                    route: "/cukai-tanah/showPengecualian",
                },
            ],
            total: 0,
            pagination: {
                perPage: 10,
                currentPage: 1,
                lastPage: 1,
            },
            statusOptions: [
                { value: null, label: "Semua" },
                { value: 1, label: "Aktif" },
                { value: 0, label: "Tidak Aktif" },
            ],

            pengecualian: {
                headers: [
                    { label: "Bil", key: "id" },
                    { label: "No. MKNK", key: "no_mknk" },
                    { label: "Nama", key: "pemilik" },
                    { label: "No. Hak Milik", key: "no_hm" },
                    { label: "No. Akaun", key: "no_akaun" },
                    // { label: "Keluasan", key: "keluasan" },
                    { label: "Tempoh Mula", key: "tempoh_mula" },
                    // { label: "Status", key: "status" },
                    { label: "Tindakan", key: "action", align: "center" },
                ],
                items: [
                    {
                        id: null,
                        no_mknk: null,
                        pemilik: null,
                        no_hm: null,
                        no_akaun: null,
                        tempoh_mula: null,
                        tempoh_tamat: null,
                        amaun: null,
                        keluasan: null,
                        status: null,
                        action: null,
                    },
                ],
            },
            searchParams: {
                no_mknk: null,
                pemilik: null,
                no_akaun: null,
                daerah: null,
                no_hm: null,
                limit: null,
                offset: null,
            },
            districts: [{ value: "null", label: "Loading..." },],
            jabatan:this.$page.props.auth.user.jabatan_id,
            id_daerah:null,
        };
    },
    methods: {
         printExcel(){

            if (this.searchParams.nama == null) {
                delete this.searchParams.nama;
            }
                  for (var key in this.searchParams) {
                    if (String(this.searchParams[key]) === "null" || String(this.searchParams[key]) === "undefined") {
                      delete this.searchParams[key];
                    }
                  }
                var queryString = Object.keys(this.searchParams)
                .map((key) => key + "=" + this.searchParams[key])
                .join("&");
                window.open( `${this.apiBaseUrl}/cukai/pengecualian/printExcel?${queryString}`);
        },
        onPaginationChange(e) {
            this.pagination.currentPage = e.value.currentPage;
            this.pagination.perPage = e.value.perPage;
            this.fetchData2();
        },

        filter() {
            this.pagination.currentPage = 1;
            this.fetchData2();
        },

        async fetchData2() {
            this.loading = true;
            this.searchParams.limit = this.pagination.perPage;
            this.searchParams.offset =
                (this.pagination.currentPage - 1) * this.pagination.perPage;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/pengecualian`,
                params: this.searchParams,
                responseType: "json",
            }).then((e) => {
                const { limit, offset, total, data } = e.data;
                this.total = total;
                this.pagination.lastPage = Math.ceil(total / limit);
                this.pengecualian.items = data.map((d) => {
                    return {
                        id: d.id,
                        no_mknk: d.no_mknk,
                        pemilik: d.pemiliks
                            .map((w) => {
                                return w.nama;
                            })
                            .join("<br/>"),
                        no_hm: d.no_hm,
                        no_akaun: d.no_akaun,
                        tempoh_mula: d.tarikh_mula,
                        tempoh_tamat: d.tarikh_tamat,
                        amaun: d.amaun,
                        keluasan: d.keluasan,
                        status: d.status,
                        action: d.id,
                    };
                });
            });

            this.loading = false;
        },
        async fetchDaerah() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.id,
                    };
                });
            });
        },
        async getDaerah(){
            this.loading = true;
            await axios({
                    method: "get",
                    url: `${this.apiBaseUrl}/jabatanToDaerah?jabatan=${this.jabatan}`,
                    responseType:'json',
                }).then((e)=>{
                    this.searchParams.daerah=e.data[0].lkp_daerah_id;
                    this.id_daerah=e.data[0].lkp_daerah_id;
                }).finally((e) => {
                    this.fetchData2();
                });;
        },
    },
    watch: {},
    computed: {
        getLastPage() {
            return this.total > 0
                ? Math.ceil(this.total / this.pagination.perPage)
                : 1;
        },
    },
    mounted() {
        this.getDaerah();
        this.fetchDaerah();
        this.dialog.width = 500;
    },
};
</script>
